import React from "react";
import { ErrorWrap } from "./styled";

const NotFoundPage = () => {

  return (
    <ErrorWrap>
      <div>
        <h1>404 - Not Found</h1>
        <p>Oops! The page you&apos;re looking for does not exist.</p>
      </div>
    </ErrorWrap>
  );
};

export default NotFoundPage;
